import ShippingEventView from "../../views/ShippingEvent";
import { ecommerceStoreId, apiPath } from "../../constants";

import { dataSourceV2 } from "../../../../commons-ui/core/DataSource";
export default ShippingEventView;
